// extracted by mini-css-extract-plugin
export var details = "_iv-0";
export var inspectorPopover = "_iv-1";